import axios from 'axios';
axios.defaults.headers.post['Content-Type']  =  'application/x-www-form-urlencoded';
import qs from 'qs';


const setMainCourse = ({body}) => axios.post('domain/mainCourse', JSON.stringify(body), {
    headers: {
        'Content-Type': 'application/json'
    }
});
const categoriesByCorpAndType = (id_corporation, id_category_type, catalogue_path) => axios.get(`domain/categories/${id_corporation}/${id_category_type}${catalogue_path}`);
const getCategories = ({filters}) => axios.get(`domain/category`, {
    params: filters
});
const saveCategory = ({body}) => axios.post(`domain/category`, JSON.stringify(body), {
    headers: {
      'Content-Type': 'application/json'
    }
  });
const saveCategoryImport = ({body}) => axios.post(`domain/categoryImport`, body);
const saveCourseCatCate = ({body}) => axios.post(`domain/saveCourseCatCate`, body);
const getCourseCatCate = ({filters}) => axios.get(`domain/courseCatCate/${filters.catalogue_name}`);
const updateCategory = ({category}) => axios.put(`domain/category/${category.id_category}`, category);
const deleteCategory = ({category}) => axios.delete(`domain/category/${category.id_category}`);
const uploadCategoryFile = ({body}) => axios.post(`domain/categoryUploadUrl`, JSON.stringify(body), {
  headers: {
    'Content-Type': 'application/json'
  }
});
const patchTheme = ({themeId, body}) => axios.patch(`theme/${themeId}`, body );


const domain = axios.create({
    baseURL: URL_DOMAIN_API
});

const rootApp = axios.create({
    baseURL: ''
});

domain.interceptors.request.use((request) => {
    request.headers.Authorization = localStorage.getItem('token');
    //console.log('token'+request.headers.Authorization);
    return request;
}, error => Promise.reject(error));
axios.interceptors.response.use(response => response, error =>
    Promise.reject(error),
);

const getDynamicFields = ({body}) => domain.post(`domain/getDynamicFields`, body);
const saveDynamicFields = ({body}) => domain.post(`domain/saveDynamicFields`, qs.stringify(body));
const deleteDynamicFields  = ({body}) => domain.post(`domain/deleteDynamicFields`,qs.stringify(body));
const orderDynamicFields = ({body}) => domain.post(`domain/orderDynamicFields`, qs.stringify(body));
const orderCourseTeam = ({body}) => domain.post(`domain/orderCourseTeam`, qs.stringify(body));
const getEmailTracking = ({body}) => domain.post(`domain/getEmailTracking`, qs.stringify(body));
const resetLogEvent = ({body}) => domain.post(`domain/resetLogEvent`, qs.stringify(body));
const putAuditLogs = ({body}) => domain.post(`domain/putAuditLogs`, qs.stringify(body));
const getFieldUsage = ({body}) => domain.post(`domain/getFieldUsage`, qs.stringify(body));

const getMyCatalogues = ({body}) => domain.post(`domain/getMyCatalogues `, qs.stringify(body));
const getLabelCategoryCatalogue = (catalogue_name, id_corporation) => domain.get(`domain/getLabelCategoryCatalogue/${catalogue_name}/${id_corporation}`);
const getCataloguesByCourse = (id_course) => axios.get(`domain/cataloguesByCourse/${id_course}`);

const cataloguePeople = (body) => domain.post(`reports/cataloguePeople`, qs.stringify(body));

//crudActions
const crudActions = ({body}) => domain.post(`domain/actions `, qs.stringify(body), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}});

const getCoursesAverage = ({body}) => domain.post(`reports/getCoursesAverage`, qs.stringify(body));
const getCourseAllUsers = ({body}) => domain.post(`reports/getCourseAllUsers`, qs.stringify(body));


const crudDataUser = ({body}) => domain.post(`user/crudDataUser`, qs.stringify(body));

const crudDataBilling = ({body}) => domain.post(`user/crudDataBilling`, qs.stringify(body));

const crudDataInstructor = ({body}) => domain.post(`user/crudDataInstructor`, qs.stringify(body));

const rawData = ({body}) => rootApp.post('index.php?r=aprendo/AnalyticsReport', qs.stringify(body));

const getCourseByUsers = ({body}) => domain.post(`reports/getCourseByUser`, qs.stringify(body));
const getManagedCourseByUsers = ({body}) => domain.post(`reports/getManagedCourseByUser`, qs.stringify(body));

const crudForms = ({body}) => domain.post(`domain/forms `, qs.stringify(body));

const crudTeams = ({body}) => domain.post(`domain/teams `, qs.stringify(body));

const reportFormCourse = ({body}) => domain.post(`reports/getFormCourse `, qs.stringify(body));

const courseStatus = ({body}) => domain.post(`domain/updateCourseStatus`, qs.stringify(body));

const manageLists = ({body}) => domain.post(`lists/manageLists`, qs.stringify(body));

const previewEmailEvent = (body) => domain.post(`events/getPreviewEmail`, qs.stringify(body));

const externalInstructors = () => domain.get('domain/externalInstructors');
const updateExternalInstructors = (externalInstructors) => domain.put('domain/externalInstructors', externalInstructors);

//PATHS & REWARDS
const paths = ({body}) => domain.post(`domain/paths`, qs.stringify(body));
const rewards = ({body}) => domain.post(`rewards/getRewardUploadURL`, qs.stringify(body));


//const getCorporationLabels = ({domain,lang,search}) => domain.post(`corporation/getLabels`, qs.stringify({domain,lang,search}));
//const getCorporationLabels = ({domain,lang,search}) => domain.post(`corporation/getLabels`, qs.stringify({domain,lang,search}));

const corporationLabels = (lang) => domain.get(`corporation/labels/${lang}`);
const getCorporationLabels = (lang) => domain.post(`corporation/labels/${lang}`, JSON.stringify({domain: window.DOMAIN}));
const updateCorporationLabels = (lang, corporationLabels) => domain.put(`corporation/labels/${lang}`, corporationLabels);

const applications = ({body}) => domain.post(`domain/applications`, qs.stringify(body))
export default {
    applications,
    setMainCourse,
    getCategories,
    saveCategory,
    saveCourseCatCate,
    getCourseCatCate,
    saveCategoryImport,
    updateCategory,
    deleteCategory,
    uploadCategoryFile,
    patchTheme,
    getDynamicFields,
    saveDynamicFields,
    getFieldUsage,
    deleteDynamicFields,
    orderDynamicFields,
    orderCourseTeam,
    getEmailTracking,
    resetLogEvent,
    crudActions,
    getCoursesAverage,
    getCourseAllUsers,
    crudDataUser,
    crudDataBilling,
    crudDataInstructor,
    rawData,
    getCourseByUsers,
    getManagedCourseByUsers,
    getMyCatalogues,
    getLabelCategoryCatalogue,
    putAuditLogs,
    getCataloguesByCourse,
    cataloguePeople	,
    crudForms,
    crudTeams,
    reportFormCourse,
    courseStatus,
    manageLists,
    previewEmailEvent,
    externalInstructors,
    updateExternalInstructors,
    paths,
    rewards,
    corporationLabels,
    getCorporationLabels,
    updateCorporationLabels,
    categoriesByCorpAndType,
//    getCorporationLabels,
};
